import React, {useEffect, useState} from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import {Button, Container, Form, Grid, Header, Segment} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {handleLogError} from '../misc/Helpers'
import {authApi} from '../misc/AuthApi'

function Profile() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'
  const navigate = useNavigate()

  const [username, setUsername] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [carModel, setCarModel] = useState('')
  const [carNumber, setCarNumber] = useState('')

  useEffect(() => {
    getMe()
  }, [])

  const getMe = async () => {
    try {
      const myUser = await authApi.getMe(user)
      setUsername(myUser.data.username)
      setName(myUser.data.name)
      setPhone(myUser.data.phone)
      setCarNumber(myUser.data.carNumber)
      setCarModel(myUser.data.carModel)
    } catch (error) {
      handleLogError(error)
    }
  }

  const handleUpdateUser = async () => {
    try {
      const newUser = {
        username: username, name: name, phone: phone, carModel: carModel, carNumber: carNumber
      }
      console.log(newUser)
      await authApi.updateUser(user, newUser)
      navigate('/')
    } catch (error) {
      handleLogError(error)
    }
  }

  const handleInputChange = (e, {name, value}) => {
    if (name === 'name') {
      setName(value)
    } else if (name === 'phone') {
      setPhone(value)
    } else if (name === 'carModel') {
      setCarModel(value)
    } else if (name === 'carNumber') {
      setCarNumber(value)
    }
  }

  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <Header as='h1' textAlign='center'>Профиль {username}</Header>
      <Grid textAlign='center'>
        <Grid.Column style={{maxWidth: 450}}>
          <Form size='large' onSubmit={handleUpdateUser}>
            <Segment>
              <Form.Input
                label='Имя'
                name='name'
                value={name}
                onChange={handleInputChange}
              />
              <Form.Input
                label='Телефон'
                name='phone'
                value={phone}
                onChange={handleInputChange}
              />
              <Form.Input
                label='Модель авто'
                name='carModel'
                value={carModel}
                onChange={handleInputChange}
              />
              <Form.Input
                label='Гос номер'
                name='carNumber'
                value={carNumber}
                onChange={handleInputChange}
              />
              <Button icon size='large' color='blue' disabled={phone === ''}>
                Сохранить
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </Container>
  )
}

export default Profile
